export const USER_TYPE = {
  ESTATE: 'estate',
  COMPANY: 'company',
  INDIVIDUAL: 'individual',
  USER: 'user'
}
